export default __webpack_public_path__ + "static/assets/bc0fbf502b38884f440135ddae40016d.svg";